import { atom } from "recoil";
import { ocPersistAtom } from "oc/states/persist-atom";

export const myCafeteriaAddItemResultState = atom({
  key: "myCafeteriaAddItemResultState",
  default: {
    result: false,
    messages: [],
  },
  effects_UNSTABLE: [ocPersistAtom],
});

export default myCafeteriaAddItemResultState;
